// App.jsx
import React from 'react';
import { AnimatePresence } from 'framer-motion';
import AppRoutes from './Routes';
import ScrollToTop from './Components/ScrollToTop';
import Footer from './Components/Footer';
import Header from './Components/Header';
import UseScrollToTop from './hooks/useScrollToTop';
import Mobilenavbar from './Components/Header/MobileHeader';

function App() {
  return (
    <div className="w-full transition duration-300">
      <AnimatePresence>
      {/* <Header key="uniqueKey1" className="block lg:hidden" /> */}
      {/* <Mobilenavbar key="uniqueKey1" className="hidden lg:block"/> */}
      <AppRoutes key="uniqueKey2" />
      {/* <Footer key="uniqueKey3" /> */}
      {/* <UseScrollToTop  key="uniqueKey4"/> */}
      {/* <ScrollToTop key="uniqueKey5"/> */}
      </AnimatePresence >
    </div>
  );
}

export default App;
